<template>
    <div>
      <div class="container" :style="{minHeight:minHeight + 'px'}">
        <Head msg="Welcome to Your Vue.js App"/>
        <img style="width:100%;height:300px;" src="./../../assets/image/back/qiyeziping_back.jpg" alt="">
        <div class="content">
<div class="title">AI企业创新能力评估</div>

<!-- 核心算法与模型能力 -->
<div class="section-title">一、核心算法与模型能力</div>

<div class="basicevaluate">
<h1>21. 开源榜单上榜情况 <span class="tag">4选2</span></h1>
<el-checkbox-group v-model="AiEvaluateForm.openSourceRanking" @change="handleOpenSourceChange">
<el-row>
    <el-col :span="24"><el-checkbox label="1">国际顶级开源榜单（如 GitHub Trending、Hugging Face Top Models 等）上榜</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="2">国内权威开源榜单（如 OpenI、Gitee 等）上榜</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="3">行业专业榜单上榜</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="4">未上榜</el-checkbox></el-col>
</el-row>
</el-checkbox-group>
</div>

<div class="basicevaluate">
<h1>22. 核心算法/模型备案情况 <span class="tag required">核心必选</span></h1>
<el-radio-group v-model="AiEvaluateForm.modelFiling">
<el-row>
    <el-col :span="12"><el-radio label="1">已完成国家网信办算法备案</el-radio></el-col>
    <el-col :span="12"><el-radio label="0">未完成备案</el-radio></el-col>
</el-row>
</el-radio-group>
</div>

<div class="basicevaluate">
<h1>23. 大模型/专用模型技术落地场景数 <span class="tag required">核心必选</span></h1>
<el-input-number v-model="AiEvaluateForm.modelScenes" :min="0" :max="100" style="width: 200px;"></el-input-number>
<span style="margin-left: 10px;">个</span>
</div>

<!-- 数据资产与算力基础 -->
<div class="section-title">二、数据资产与算力基础</div>

<div class="basicevaluate">
<h1>24. 数据资产化管理与安全水平 <span class="tag required">核心必选</span></h1>
<el-radio-group v-model="AiEvaluateForm.dataManagement">
<el-row>
    <el-col :span="12"><el-radio label="1">已建立数据资产管理体系并通过安全认证</el-radio></el-col>
    <el-col :span="12"><el-radio label="0">未建立或未完成认证</el-radio></el-col>
</el-row>
</el-radio-group>
</div>

<div class="basicevaluate">
<h1>25. 算力资源投入强度 <span class="tag required">核心必选</span></h1>
<el-input-number v-model="AiEvaluateForm.computingPower" :min="0" :precision="2" style="width: 200px;"></el-input-number>
<span style="margin-left: 10px;">万元/PFLOPS</span>
</div>

<!-- 智能硬件与装备创新 -->
<div class="section-title">三、智能硬件与装备创新</div>

<div class="basicevaluate">
<h1>26. 智能装备/解决方案规模化部署量 <span class="tag">核心必选/4选2</span></h1>
<el-input-number v-model="AiEvaluateForm.equipmentDeployment" :min="0" :max="10000" style="width: 200px;"></el-input-number>
<span style="margin-left: 10px;">套</span>
</div>

<div class="basicevaluate">
<h1>27. 自主可控与供应链安全能力 <span class="tag">4选2</span></h1>
<el-checkbox-group v-model="AiEvaluateForm.supplyChain" @change="handleSupplyChainChange">
<el-row>
    <el-col :span="24"><el-checkbox label="1">核心芯片/硬件实现自主可控</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="2">关键软件框架自主开发</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="3">建立多元化供应链体系</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="4">依赖外部供应链</el-checkbox></el-col>
</el-row>
</el-checkbox-group>
</div>

<!-- 产业融合与价值实现 -->
<div class="section-title">四、产业融合与价值实现</div>

<div class="basicevaluate">
<h1>28. 跨行业场景融合效能 <span class="tag">4选2</span></h1>
<el-checkbox-group v-model="AiEvaluateForm.industryFusion" @change="handleIndustryFusionChange">
<el-row>
    <el-col :span="24"><el-checkbox label="1">在3个及以上行业实现AI应用落地</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="2">形成可复制的行业解决方案</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="3">产生显著经济效益（年收入增长>20%）</el-checkbox></el-col>
    <el-col :span="24"><el-checkbox label="4">仅在单一行业应用</el-checkbox></el-col>
</el-row>
</el-checkbox-group>
</div>

<!-- 企业内生智能化水平 -->
<div class="section-title">五、企业内生智能化水平</div>

<div class="basicevaluate">
<h1>29. 企业内部运营AI原生化程度 <span class="tag required">核心必选</span></h1>
<el-radio-group v-model="AiEvaluateForm.aiNative">
<el-row>
    <el-col :span="12"><el-radio label="1">核心业务流程已实现AI原生化</el-radio></el-col>
    <el-col :span="12"><el-radio label="0">部分流程AI化或尚未AI化</el-radio></el-col>
</el-row>
</el-radio-group>
</div>

<div class="enterbtn">
            <el-button type="success" style="padding:15px" @click="aiEvaluateSubmit">确认并提交</el-button>           
          </div>                                 
        </div>
        </div>
        <Footer msg="Welcome to Your Vue.js App"/>
    </div>
</template>

<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      minHeight: 0,
      AiEvaluateForm: {
        openSourceRanking: [],
        modelFiling: "",
        modelScenes: 0,
        dataManagement: "",
        computingPower: 0,
        equipmentDeployment: 0,
        supplyChain: [],
        industryFusion: [],
        aiNative: ""
      }
    };
  },
  methods: {
    handleOpenSourceChange() {
      if (this.AiEvaluateForm.openSourceRanking.includes("4")) {
        this.AiEvaluateForm.openSourceRanking = ["4"];
      }
    },
    handleSupplyChainChange() {
      if (this.AiEvaluateForm.supplyChain.includes("4")) {
        this.AiEvaluateForm.supplyChain = ["4"];
      }
    },
    handleIndustryFusionChange() {
      if (this.AiEvaluateForm.industryFusion.includes("4")) {
        this.AiEvaluateForm.industryFusion = ["4"];
      }
    },
    aiEvaluateSubmit() {
      if (!this.AiEvaluateForm.modelFiling) {
        this.$message.warning("请填写核心算法/模型备案情况");
        return;
      }
      if (!this.AiEvaluateForm.dataManagement) {
        this.$message.warning("请填写数据资产化管理与安全水平");
        return;
      }
      if (!this.AiEvaluateForm.aiNative) {
        this.$message.warning("请填写企业内部运营AI原生化程度");
        return;
      }
      
      this.$confirm(
        "确认提交AI企业创新能力评估信息？",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info"
        }
      ).then(() => {
        this.$message.success("评估信息已提交，等待审核");
        this.$router.push({ path: "/" });
      }).catch(() => {});
    }
  },
  mounted() {
    this.minHeight = document.documentElement.clientHeight - 200;
    var me = this;
    window.onresize = function() {
      me.minHeight = document.documentElement.clientHeight - 200;
    };
  },
  components: {
    Head,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  min-height: 1300px;
  margin: 0 auto;
  background-color: #f5f5f5;
}
.title {
  height: 50px;
  margin: 50px 0 0;
  line-height: 50px;
  color: #ffffff;
  background-color: #0088d2;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.section-title {
  height: 40px;
  margin: 30px 0 0;
  line-height: 40px;
  color: #ffffff;
  background-color: #409eff;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.basicevaluate {
  text-align: left;
  padding: 0 30px;
  h1 {
    padding: 30px 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.6;
  }
  .tag {
    display: inline-block;
    padding: 2px 8px;
    margin-left: 10px;
    font-size: 12px;
    color: #909399;
    background-color: #f4f4f5;
    border-radius: 3px;
    font-weight: normal;
  }
  .tag.required {
    color: #f56c6c;
    background-color: #fef0f0;
  }
}
.enterbtn {
  margin-top: 50px;
  margin-bottom: 30px;
  text-align: center;
}

@media (max-width: 767.98px) {
  .content {
    width: 100% !important;
    height: auto !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
  .basicevaluate {
    padding: 0 !important;
  }
  .basicevaluate h1 {
    padding: 15px 0 !important;
    font-size: 16px !important;
  }
  .enterbtn {
    text-align: center !important;
  }
  .el-checkbox {
    display: flex !important;
    align-items: flex-start !important;
    white-space: normal !important;
    margin-bottom: 8px !important;
  }
  .el-checkbox__label {
    white-space: normal !important;
    word-break: break-word !important;
    line-height: 1.5 !important;
  }
}
</style>
